import {observer} from "mobx-react";
import TranslationScope from "../../../../../../translation/translation-scope";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import {useEffect} from "react";
import usePage from "../../../../../../components/layouts/base-page-layout/page-hook";
import PackingSlipTranslationsEditor from "./packing-slip-translations-editor";

const PackingSlipTranslationsEditorPage: React.FC = observer(() => {
    const {setSubTitles, setInstruction} = usePage();

    useEffect(() => {
        setSubTitles(['Return Methods', 'Packing Slip']);
        setInstruction(undefined);
    }, [setSubTitles, setInstruction]);

    const {selectedLocale} = useTranslation();

    return (
        <TranslationScope scope="packing-slip" locale={selectedLocale}>
            <PackingSlipTranslationsEditor/>
        </TranslationScope>
    );
});

export default PackingSlipTranslationsEditorPage;